var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[((_vm.currentStage > 3 && !_vm.isBinance) || (_vm.currentStage > 3 && !_vm.hasClaim))?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('InfoBlock',{staticClass:"staking-card--inline",attrs:{"label":_vm.$t('upcoming.tokens-bought'),"data":`${_vm.amountFilter(isNaN(_vm.info.tokensBought) ? 0 : _vm.info.tokensBought, 5)} ${
          _vm.info.token || '...'
        }`}})],1)],1):(_vm.currentStage > 3)?_c('v-row',[_c('v-col',{attrs:{"sm":"4","cols":"12"}},[_c('InfoBlock',{attrs:{"label":_vm.$t('upcoming.tokens-bought'),"data":`${_vm.amountFilter(isNaN(_vm.info.tokensBought) ? 0 : _vm.info.tokensBought, 5)} ${
          _vm.info.token || '...'
        }`}})],1),_c('v-col',{attrs:{"sm":"4","cols":"12"}},[_c('InfoBlock',{attrs:{"label":_vm.$t('upcoming.claimed-so-far'),"data":_vm.info.isClaimed
            ? `${_vm.amountFilter(_vm.info.tokensBought, 5)} ${_vm.info.token}`
            : `${_vm.amountFilter('0', 4)} ${_vm.info.token}`}})],1),_c('v-col',{attrs:{"sm":"4","cols":"12"}},[_c('InfoBlock',{attrs:{"label":_vm.$t('upcoming.left-to-claim'),"data":_vm.info.isClaimed
            ? `${_vm.amountFilter('0', 4)} ${_vm.info.token}`
            : `${_vm.amountFilter(isNaN(_vm.info.tokensBought) ? 0 : _vm.info.tokensBought, 5)} ${_vm.info.token}`}})],1)],1):(_vm.currentStage != 0)?_c('v-row',[_c('v-col',{attrs:{"sm":"6","cols":"12"}},[_c('InfoBlock',{attrs:{"label":_vm.$t('upcoming.rate'),"data":`1 ${_vm.info.token || '...'} = ${_vm.info.tokenPrice} ${_vm.info.paymentToken || '...'}`}})],1),_c('v-col',{attrs:{"sm":"6","cols":"12"}},[(_vm.currentStage > 2)?_c('InfoBlock',{attrs:{"label":_vm.$t('upcoming.allocation'),"data":`
            ${_vm.amountFilter(_vm.info.currentAllocation > 0 ? _vm.info.stakeAllocationAmount : 0, 5)}
            ${_vm.info.paymentToken || '...'}`,"list":[
          `Left to buy - ${_vm.amountFilter(
            _vm.info.currentAllocation > 0 ? _vm.$BN(_vm.info.leftToBuy) : '0',
            5,
          )} ${_vm.info.paymentToken || '...'}`,
          `Bought - ${_vm.amountFilter(isNaN(_vm.info.bought) ? 0 : _vm.info.bought, 5)} ${
            _vm.info.paymentToken || '...'
          }`,
        ]}}):_c('InfoBlock',{attrs:{"label":_vm.$t('upcoming.allocation'),"data":`
          ${_vm.amountFilter(_vm.info.currentAllocation > 0 ? _vm.info.stakeAllocationAmount : 0, 5)}
          ${_vm.info.paymentToken || '...'}`,"list":[
          `Allocation - ${_vm.amountFilter(
            _vm.info.currentAllocation > 0
              ? _vm.$BN((_vm.info.tokenAmount * _vm.info.allocationPercent) / 100)
              : '0',
            5,
          )} ${_vm.info.token || '...'}`,
          `For your participant stake share - ${_vm.amountFilter(
            _vm.info.currentAllocation ? _vm.$BN(_vm.info.currentAllocation) : 0,
            5,
          )} ${_vm.token}`,
          `Your total stake - ${_vm.amountFilter(_vm.info.stake ? _vm.$BN(_vm.info.stake) : 0, 5)} ${_vm.token}`,
          `Minimum stake - ${_vm.amountFilter(_vm.info.minStake ? _vm.$BN(_vm.info.minStake) : 0, 5)} ${_vm.token}`,
          `Maximum stake - ${_vm.amountFilter(
            _vm.info.maximumStake ? _vm.$BN(_vm.info.maximumStake) : 0,
            5,
          )} ${_vm.token}`,
          `Total / max participants - ${_vm.info.participants} / ${
            Number(_vm.info.maxParticipants) > 9999 ? 'unlimited' : _vm.info.maxParticipants
          }`,
        ]}})],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }